module.exports = __webpack_public_path__ + "static/media/occasion-thank-yous.a4480749.png";